import { Boxes } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const lotsNav: NavEntry = {
  // 'Lot traceability', not the audit's 'Lots and traceability' (owner,
  // 2026-08-16): the 'and' reads cleaner and the page it opens is headed the
  // same way. Slightly narrower in meaning — the register also holds lots that
  // have no traceability links yet — and that was an accepted trade.
  label: 'Lot traceability',
  icon: Boxes,
  path: '/quality/lots',
  permission: 'lots:read',
  order: 22,
}
